/**
 * Surveille le branchement et le débranchement des manettes, quel que soit le mode de l'écran client.
 *
 * - API Gamepad : `gamepadconnected` / `gamepaddisconnected` (Chrome ne signale une manette qu'après un premier appui) ;
 * - WebHID : `connect` / `disconnect` des manettes PlayStation déjà autorisées, signalés dès le branchement.
 *
 * `quandChange(presente)` n'est appelée qu'aux changements : true quand la première manette arrive,
 * false quand la dernière est partie. Une manette déjà branchée à l'ouverture de la page n'est pas une arrivée.
 * Rend la fonction qui arrête la surveillance.
 */
const VENDEUR_SONY = 0x054c;

export function surveillerManettes(quandChange) {
    const presentes = new Set();
    let etat = false;

    const maj = () => {
        const maintenant = presentes.size > 0;
        if (maintenant !== etat) {
            etat = maintenant;
            quandChange(maintenant);
        }
    };

    const surGamepadArrive = e => { presentes.add("gamepad-" + e.gamepad.index); maj(); };
    const surGamepadParti = e => { presentes.delete("gamepad-" + e.gamepad.index); maj(); };
    const surHidArrive = e => { if (e.device.vendorId === VENDEUR_SONY) { presentes.add(e.device); maj(); } };
    const surHidParti = e => { presentes.delete(e.device); maj(); };

    window.addEventListener("gamepadconnected", surGamepadArrive);
    window.addEventListener("gamepaddisconnected", surGamepadParti);
    if (navigator.hid) {
        navigator.hid.addEventListener("connect", surHidArrive);
        navigator.hid.addEventListener("disconnect", surHidParti);
    }

    return () => {
        window.removeEventListener("gamepadconnected", surGamepadArrive);
        window.removeEventListener("gamepaddisconnected", surGamepadParti);
        if (navigator.hid) {
            navigator.hid.removeEventListener("connect", surHidArrive);
            navigator.hid.removeEventListener("disconnect", surHidParti);
        }
    };
}
